
export const servingPreferenceOptions = [
    {label: "Individually", value: "Individually"},
    {label: "Couple", value: "Couple"},
    {label: "Group", value: "Group"},
    {label: "Family", value: "Family"},
] as const

/**
 * Service Preference Options
 */
export const servingPreferenceOptionsLabels = servingPreferenceOptions.map(option => option.label)

export const servingPreferenceOptionsValues = servingPreferenceOptions.map(option => option.value)

export type ServingPreferenceOptionValue = typeof servingPreferenceOptionsValues[number]

/**
 * Meal Preparation Options
 */
export const mealPreparationAbilityOptions = [
    { label: "Yes", value: "yes" },
    { label: "No", value: "no" },
    { label: "Willing to help if needed", value: "willing" },
    { label: "Prefer not to cook", value: "prefer_not" },
    { label: "Experienced cook", value: "experienced" }
] as const

export const mealPreparationAbilityOptionsLabels = mealPreparationAbilityOptions.map(option => option.label)

export const mealPreparationAbilityOptionsValues = mealPreparationAbilityOptions.map(option => option.value)

export type MealPreparationAbilityOptionsValue = typeof mealPreparationAbilityOptionsValues[number]


// Give me a list of options for a language that is not in the list of options
export const otherLanguageOptions = [
    { label: "None", value: "none" },
    { label: "French", value: "french" },
    { label: "Spanish", value: "spanish" },
    { label: "German", value: "german" },
    { label: "Italian", value: "italian" },
    { label: "Portuguese", value: "portuguese" },
    { label: "Russian", value: "russian" },
    { label: "Other", value: "other" },
] as const


export const availabilityOptions = [
    { label: "Daily", value: "daily" },
    { label: "Weekly", value: "weekly" },
    { label: "Monthly", value: "monthly" },
    { label: "Yearly", value: "yearly" },
] as const

